import {AlertType, AlertSeverity} from '../../../models/IAlert';

export const ALERT_LABELS: Record<AlertType, string> = {
    ENGINE_CHECK: '⚠️ Ошибка двигателя',
    LOW_FUEL: '⛽ Мало топлива',
    LOW_VOLTAGE: '🔋 Низкое напряжение',
    ENGINE_FIRST_START: '🟢 Первый запуск',
    FIRST_MOVEMENT: '🟢 Первое движение',
    FUEL_REFILL: '⛽ Заправка',
    FUEL_DRAIN: '🚨 Слив топлива',
    ENGINE_OVERHEAT: '🌡️ Перегрев двигателя',
    OVERSPEED: '🚨 Превышение скорости',
    HIGH_VOLTAGE: '🔋 Повышенное напряжение',
    OIL_LOW: '🛢️ Низкое давление масла',
    OIL_HIGH: '🛢️ Высокое давление масла',
    HIGH_RPM: '⚙️ Высокие обороты',
    BEACON_LOW_BATTERY: '📡 Разряд батареи маяка',
};

export const SEVERITY_COLOR: Record<AlertSeverity, 'success' | 'warning' | 'error'> = {
    info: 'success',
    warning: 'warning',
    critical: 'error',
};
